import angular from 'angular';
import updateNoteModal from './updateNoteModal';
import insuranceNoteTemplatesModal from './insuranceNoteTemplatesModal';

export default angular
  .module('components.insuranceNoteTemplatesModal', [])
  .component('insuranceNoteTemplatesModal', insuranceNoteTemplatesModal)
  .component('updateNoteModal', updateNoteModal).name;
